import BaseService from './BaseService';
import apiTargets from '@/config/apiTargets';
import axios from 'axios'
import router from 'src/routes/router'
import config from 'src/config'
const { CLOUD_HOST, API_HOST } = config;

let cache = {

}
class PublicService extends BaseService{

  constructor() {
    super({ apiTarget: apiTargets.PUBLIC });
  }

  getConfig() {
    return this.instance.get('/configuration');
  }

  _updateInstanceBaseUrls(newHost) {
    return BaseService.updateInstanceBaseUrls(newHost)
  }

  async _getApiHost () {
    let instance = axios.create({})
    let res = null
    try {
      res = await instance.post(`${CLOUD_HOST}/api/v1/public/host`, {
        host: window.location.hostname
      })
    } catch (e) {
      console.warn(e)
    }
    if(res) {
      let host = res.data.hosts.find(h => h.type === 'api')
      return host ? host.host : null
    } else {
      return null
    }
  }

  async updateApiHost () {
    let storageHost = cache['api-host'] || localStorage.getItem('api-host')
    if (storageHost === 'https://api.carriere.nu' && window.location.origin !== 'https://admin.carriere.nu') {
      // old default settings from env. We shouldn't allow this anymore. api.carriere.nu was the default production api once :(
      await router.push('/404')
      return
    }
    if (storageHost) {
      this._updateInstanceBaseUrls(storageHost)
      return
    }
    let host = ''
    try {
      host = await this._getApiHost()
    } catch (e) {
      // Retry in case it fails. Sometimes it happens to fail on the first request
      host = await this._getApiHost()
    }
    if (host) {
      let hostUrl = `https://${host}`
      cache['api-host'] = hostUrl
      localStorage.setItem('no-api-host', '')
    } else {
      cache['api-host'] = API_HOST
      localStorage.setItem('no-api-host', 'true')
    }
    localStorage.setItem('api-host', cache['api-host'])
    if (!cache['api-host']) {
      await router.push('/404')
      return
    }
    this._updateInstanceBaseUrls(cache['api-host'])
  }
}

export default new PublicService();
